import PatTry from "../../../../football/rules/offensive/pat/pat-try";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

export default class FlagPatTry extends PatTry {
    kickoffContextChanges(gameContext) {
        // Without kickoffs the ball goes straight to the next team, so the
        // PAT has to arm the following drive itself.
        //
        // With kickoffs enabled the kickoff opens the receiving team's drive
        // instead - which is why the base hook is a no-op for tackle. Arming
        // a drive here as well pre-opens one the kickoff cannot then be
        // entered into, and ValidationService throws KickoffIntoActiveDrive.
        if (isKickoffEnabled(gameContext)) return;

        gameContext.setDriveContext({
            triggerDrive: true
        });
    }
}
